import React from 'react';

import type { DomainShopResponse } from '@/Swagger';
import type { DomainPlanExt, useShopPlansDetail } from '@/app/plan/services';
import type useGetShopInfo from '@/app/shop/shop-info/useGetShopInfo';

export const ShopInfoContext = React.createContext<{
  shopInfo: DomainShopResponse & {
    서비스_사용에_따른_설정값: {
      enableDetailImage: boolean;
      enableBackgroundRemoved: boolean;
      marginAdjust: boolean;
      enableAutoGenerateTitle: boolean;
      imageFilterEnabled: boolean;
      enableUploadImageRatio: boolean;
      enableAutoPrice: boolean;
      enableSearchKeywordTemplate: boolean;
      enableAutoSizeAssignment: boolean;
      enableAutoFabricClassification: boolean;
      enableAutoRotateImage: boolean;
      isAutoInputOrigin: boolean;
    };
  };
  refetch: ReturnType<typeof useGetShopInfo>['refetch'];
} | null>(null);

export const ShopPlanContext = React.createContext<{
  shopPlan: DomainPlanExt;
  refetch: ReturnType<typeof useShopPlansDetail>['refetch'];
} | null>(null);

/**
 * Shop 정보를 가져옵니다.
 *
 * @deprecated useShopInfo2 로 마이그레이션 후 훅 이름 변경.
 */
export const useShopInfo = () => {
  const shopInfo = React.useContext(ShopInfoContext);
  if (!shopInfo) {
    throw new Error('"useShopInfo" was NOT used in "ShopInfoProvider" component.');
  }
  return shopInfo.shopInfo;
};

/**
 * Shop 정보를 가져옵니다.
 */
export const useShopInfo2 = () => {
  const shopInfo = React.useContext(ShopInfoContext);
  if (!shopInfo) {
    throw new Error('"useShopInfo" was NOT used in "ShopInfoProvider" component.');
  }
  return shopInfo;
};

/**
 * Shop 플랜 정보를 가져옵니다.
 *
 * @deprecated useShopPlan2 로 마이그레이션 후 훅 이름 변경.
 */
export const useShopPlan = () => {
  const shopPlan = React.useContext(ShopPlanContext);
  if (!shopPlan) {
    throw new Error('"useShopPlan" was NOT used in "ShopInfoProvider" component.');
  }
  return shopPlan.shopPlan;
};

/**
 * Shop 플랜 정보를 가져옵니다.
 */
export const useShopPlan2 = () => {
  const shopPlan = React.useContext(ShopPlanContext);
  if (!shopPlan) {
    throw new Error('"useShopPlan" was NOT used in "ShopInfoProvider" component.');
  }
  return shopPlan;
};
